import { render } from "./burger.vue?vue&type=template&id=9b66dd2c&scoped=true"
import script from "./burger.vue?vue&type=script&lang=js"
export * from "./burger.vue?vue&type=script&lang=js"

import "./burger.vue?vue&type=style&index=0&id=9b66dd2c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b66dd2c"]])

export default __exports__